export default class MeetingType {
    constructor() {
        this.name = "";
        this.additionalInfo = "";
        this.durationMinutes = 15;
        this.requiresLocation = false;
        this.isSelected = false;
        this.active = true;
    }
}
